<script>
  /***
   * This requires color to be passed as Hex value.
   * If an invalid color is passed, image will fail to render.
   */

  /**
   * @type {string} - The color of the logo
   * @default '#FF5F1F'
   */
  export let color = '#FF5F1F'
  const svgString = `
  <svg width="68" height="15" viewBox="0 0 68 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_83_196" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="68" height="15">
<path d="M5.62227 10.807C6.98419 10.8078 8.29097 10.2691 9.25668 9.30879C9.76298 8.80377 10.1631 8.20257 10.4335 7.54057C10.7039 6.87857 10.8392 6.16916 10.8313 5.45411C10.8385 4.74207 10.7029 4.03579 10.4325 3.37708C10.162 2.71836 9.76219 2.12057 9.25668 1.61906C8.28617 0.666099 6.9824 0.12902 5.62227 0.121895C4.19598 0.121895 2.89619 0.704186 2.05983 1.71829L1.96278 1.83496V0.349795H0V14.7238H2.04565V9.18339L2.14161 9.29243C2.97579 10.2553 4.24505 10.807 5.62227 10.807ZM1.92134 5.45411C1.92134 3.47497 3.3967 1.98108 5.35293 1.98108C7.25464 1.98108 8.74417 3.50769 8.74417 5.45411C8.74417 7.40053 7.25464 8.94349 5.35293 8.94349C3.42941 8.94785 1.92134 7.41361 1.92134 5.45411Z" fill="${color}"/>
<path d="M22.7231 10.5791V0.349726H20.7396V1.8349L20.6436 1.71822C19.7898 0.688851 18.5315 0.121826 17.1008 0.121826C15.741 0.129235 14.4377 0.666292 13.4675 1.61899C12.962 2.1205 12.5621 2.71829 12.2917 3.37701C12.0213 4.03573 11.8856 4.742 11.8929 5.45404C11.885 6.16909 12.0202 6.8785 12.2906 7.54051C12.561 8.20251 12.9611 8.80371 13.4675 9.30872C14.4327 10.269 15.7392 10.8077 17.1008 10.807C18.5315 10.807 19.7898 10.241 20.6436 9.21167L20.7396 9.09499V10.5791H22.7231ZM17.3702 8.94342C15.4379 8.94342 13.98 7.4419 13.98 5.45404C13.98 3.46618 15.4368 1.98101 17.3702 1.98101C19.3035 1.98101 20.7799 3.47491 20.7799 5.45404C20.7799 7.43317 19.3155 8.94778 17.3702 8.94778V8.94342Z" fill="${color}"/>
<path d="M55.971 10.5791V0.349726H53.9875V1.8349L53.8916 1.71822C53.0367 0.688851 51.7794 0.121826 50.3487 0.121826C48.9888 0.129756 47.6853 0.666714 46.7143 1.61899C46.2091 2.12074 45.8097 2.7186 45.5395 3.37728C45.2692 4.03596 45.1336 4.74211 45.1408 5.45404C45.1329 6.16909 45.2681 6.8785 45.5385 7.54051C45.8089 8.20251 46.2091 8.80371 46.7154 9.30872C47.6807 10.269 48.9871 10.8077 50.3487 10.807C51.7794 10.807 53.0367 10.241 53.8916 9.21167L53.9875 9.09499V10.5791H55.971ZM50.6181 8.94342C48.6858 8.94342 47.2279 7.4419 47.2279 5.45404C47.2279 3.46618 48.6858 1.98101 50.6181 1.98101C52.5503 1.98101 54.0289 3.47491 54.0289 5.45404C54.0289 7.43317 52.5623 8.94778 50.6181 8.94778V8.94342Z" fill="${color}"/>
<path d="M65.8616 0.350342L62.6983 7.59844L59.3888 0.350342H57.148L61.6384 9.84691L61.6286 9.86981L59.4456 14.7244H61.5435L68 0.350342H65.8616Z" fill="${color}"/>
<path d="M44.6379 2.07182V0C41.9925 0.00981389 39.84 1.96823 39.84 4.37481V10.5794H41.9118V4.37481C41.9151 3.10991 43.1331 2.08054 44.6379 2.07182Z" fill="${color}"/>
<path d="M35.8789 10.5808H38.2724L34.457 5.20603L38.0216 0.350342H35.7132L33.1768 4.01855L30.7037 0.350342H28.331L31.8356 5.28999L31.8127 5.32053L28.042 10.5808H30.3722L33.1572 6.56035L35.8789 10.5808Z" fill="${color}"/>
<path d="M30.3288 5.29218L26.9954 0.350342H24.6237L28.1272 5.28999L28.1054 5.32053L24.3336 10.5808H26.665L28.257 8.28105L30.3288 5.29218Z" fill="${color}"/>
</mask>
<g mask="url(#mask0_83_196)">
<path d="M68.043 -5.00011H0V19.9708H68.043V-5.00011Z" fill="${color}"/>
</g>
</svg>
  `

  /**
   * @param {string} svgString
   * @returns {string} svgDataURL
   */
  const buildSvgDataURL = (svgString) => {
    const svgDataURL = `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svgString)))}`
    return svgDataURL
  }
</script>

{#key color}
  <img src={buildSvgDataURL(svgString)} alt="Paxray Logo" />
{/key}

<style>
  img {
    position: relative;
    width: 100%;
    max-height: 100%;
  }
</style>
